import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import * as adminApi from '../api/adminApi';
import { pickErrorMessage } from '../lib/apiHelpers';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const tokenFromUrl = searchParams.get('token') || '';

  const [token, setToken] = useState(tokenFromUrl);
  const [newPassword, setNewPassword] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await adminApi.resetPassword({ token, newPassword });
      setDone(true);
    } catch (err) {
      setError(pickErrorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light p-3">
      <div className="card shadow border-0" style={{ maxWidth: 420, width: '100%' }}>
        <div className="card-body p-4 p-md-5">
          <h1 className="h4 mb-3">Reset password</h1>
          {done ? (
            <>
              <p className="text-secondary">Your password has been updated.</p>
              <Link to="/login" className="btn btn-primary w-100">
                Sign in
              </Link>
            </>
          ) : (
            <form onSubmit={handleSubmit}>
              {error ? <div className="alert alert-danger py-2">{error}</div> : null}
              <div className="mb-3">
                <label htmlFor="token" className="form-label">
                  Reset token
                </label>
                <input
                  id="token"
                  type="text"
                  className="form-control"
                  value={token}
                  onChange={(e) => setToken(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="newPassword" className="form-label">
                  New password
                </label>
                <input
                  id="newPassword"
                  type="password"
                  className="form-control"
                  autoComplete="new-password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  minLength={8}
                />
              </div>
              <button type="submit" className="btn btn-primary w-100 mb-3" disabled={busy}>
                {busy ? 'Saving…' : 'Update password'}
              </button>
              <Link to="/login" className="btn btn-outline-secondary w-100">
                Cancel
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
